import React, { useCallback, useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router-dom'
import SideBarContext from 'components/context/sidebarContext'
import AllRoutes from 'pages/Redirection/AllRoutes'
import { AuthContext } from 'hooks/context/userContext'
import { getAuthHeaders } from 'constants/getHeader'
import Cookies from 'js-cookie'
import { Provider } from 'react-redux'
import Wrapper from 'components/Shared/Wrapper'
import FallbackPage from 'hoc/FallbackPage'
import TagManager from 'react-gtm-module'
import store from './store'

const tagManagerArgs = {
  gtmId: 'GTM-KCT6JCJ'
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: true,
      retry: false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false
    }
  }
})

function App() {
  const [openSidebar, setOpenSidebar] = useState(false)
  const [mealBtn, setMealBtn] = useState(true)
  const [isLogged, setIsLogged] = useState(false)
  const token = localStorage.getItem('dindin_key')
  const login = useCallback(() => {
    setIsLogged(true)
  }, [])

  const logout = useCallback(() => {
    setIsLogged(false)
    Cookies.remove('authtoken')
  }, [])
  const value = {
    openSidebar,
    setOpenSidebar,
    mealBtn,
    setMealBtn
  }
  useEffect(() => {
    token && login()
    !token && logout()
    getAuthHeaders()
  }, [token])

  useEffect(() => {
    TagManager.initialize(tagManagerArgs)
  }, [])

  return (
    <Router>
      <Provider store={store}>
        <AuthContext.Provider value={{ isLogged, login, logout }}>
          <SideBarContext.Provider value={value}>
            <QueryClientProvider client={queryClient}>
              <>
                <Wrapper>
                  <React.Suspense fallback={<FallbackPage />}>
                    <AllRoutes />
                  </React.Suspense>
                </Wrapper>
                <div
                  style={{
                    position: 'fixed',
                    bottom: 4,
                    right: 4,
                    background: 'rgba(0,0,0,0.7)',
                    color: '#0f0',
                    fontSize: 10,
                    padding: '2px 6px',
                    borderRadius: 4,
                    zIndex: 99999,
                    pointerEvents: 'none'
                  }}
                >
                  v2026.02.22.3
                </div>
              </>
            </QueryClientProvider>
          </SideBarContext.Provider>
        </AuthContext.Provider>
      </Provider>
    </Router>
  )
}

export default App
